var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: _vm.nodeEnv === "production" ? "inspireLogin" : "" } },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "column",
            height: "100vh",
            "background-color": "rgba(0, 0, 0, 0.3)"
          }
        },
        [
          _vm.nodeEnv === "production"
            ? [
                _c("img", {
                  attrs: { src: "/static/img/中国电建.png", width: "180" }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-content",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "flex-basis": "60%"
              },
              attrs: { "grid-list-xl": "", "text-xs-center": "" }
            },
            [
              _c(
                "v-container",
                { attrs: { fluid: "", "fill-height": "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: { border: "none" },
                      attrs: {
                        row: "",
                        wrap: "",
                        "align-center": "",
                        "fill-height": ""
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { "d-flex": "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "title1",
                              staticStyle: {
                                height: "22rem",
                                color: "#fff",
                                "text-align": "left"
                              },
                              attrs: {
                                xs12: "",
                                sm6: "",
                                md6: "",
                                "offset-md1": ""
                              }
                            },
                            [
                              _vm.nodeEnv === "production"
                                ? [
                                    _c("h1", { staticClass: "title2" }, [
                                      _vm._v("中国水电七局")
                                    ])
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("h1", { staticClass: "title2" }, [
                                _vm._v("EMP设备物资综合管理系统")
                              ]),
                              _vm._v(" "),
                              _vm.nodeEnv === "production"
                                ? _c("p", { staticClass: "subtitle" }, [
                                    _vm._v("乐成七局，和融世界")
                                  ])
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: { "flex-basis": "30%" },
                              attrs: {
                                xs12: "",
                                sm8: "",
                                md4: "",
                                "fill-height": ""
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    background: "#fff",
                                    padding: "1rem",
                                    height: "100%",
                                    display: "flex",
                                    "flex-direction": "column",
                                    position: "relative"
                                  }
                                },
                                [
                                  _c(
                                    "el-tabs",
                                    {
                                      staticStyle: { overflow: "initial" },
                                      on: { "tab-click": _vm.handleClick },
                                      model: {
                                        value: _vm.model,
                                        callback: function($$v) {
                                          _vm.model = $$v
                                        },
                                        expression: "model"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "账号登录",
                                            name: "first"
                                          }
                                        },
                                        [_c("accountLogin", {})],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "短信登录",
                                            name: "second"
                                          }
                                        },
                                        [_c("phoneLogin", {})],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "el-zoom-in-bottom" } },
                                    [
                                      _vm._v(">\n                    "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.codePanel,
                                              expression: "codePanel"
                                            }
                                          ],
                                          staticStyle: {
                                            height: "370px",
                                            position: "absolute",
                                            top: "0",
                                            width: "100%",
                                            "background-color": "#FFFFFF",
                                            left: "0",
                                            "z-index": "1500"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                "align-items": "center",
                                                "justify-content": "center",
                                                "margin-top": "30px"
                                              }
                                            },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticClass:
                                                    "text-md-center mb-2"
                                                },
                                                [
                                                  _vm._v(
                                                    "下载EMP设备物资综合管理系统App"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("img", {
                                                staticStyle: {
                                                  width: "180px",
                                                  height: "180px"
                                                },
                                                attrs: { src: _vm.apkQrcodeImg }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "grey--text",
                                                  staticStyle: {
                                                    "font-size": "12px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "请使用手机浏览器扫描二维码下载"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "40px",
                                                "padding-bottom": "36px",
                                                cursor: "pointer",
                                                "font-size": "12px",
                                                color: "#666666"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.codePanel = false
                                                }
                                              }
                                            },
                                            [_vm._v("关闭")]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        color: "#666666",
                                        display: "flex",
                                        "justify-content": "center",
                                        "align-items": "center",
                                        cursor: "pointer",
                                        "line-height": "24px"
                                      },
                                      attrs: { slot: "reference" },
                                      on: {
                                        click: function($event) {
                                          return _vm.getApkQrcodeImg(1)
                                        }
                                      },
                                      slot: "reference"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("下载EMP设备物资综合管理系统APP")
                                      ]),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "ali-icon-code"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { md1: "" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        position: "fixed",
                        bottom: "0",
                        width: "100%",
                        "text-align": "center",
                        color: "#fff",
                        padding: "10px 0"
                      }
                    },
                    [
                      _c("div", [
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "20px" } },
                          [_vm._v("中国水电七局EMP设备物资综合管理系统")]
                        ),
                        _vm._v("\n\t\t\t\t      中国水利水电第七工程局有限公司")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticStyle: {
                            color: "#fff",
                            "text-decoration": "none"
                          },
                          attrs: {
                            href:
                              "https://beian.miit.gov.cn/#/Integrated/index",
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t            京ICP备 11043677号\n\t\t          "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }